import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import { getSeaports } from "api";
import errorToast from "helpers/errorToast";
import { handleRenderAddressOption } from "helpers/schedulehelper";
import SearchSelect from "pages/shipper/RequestForm/components/Common/SearchSelect";
import { ICountryStates } from "pages/shipper/RequestForm/components/Schedule/Types";
import { IPortAddress } from "pages/provider/QuotationForm/components/Schedule/ScheduleTypes";

interface IPortInfoProps {
  prefix: string;
  countries: ICountryStates[];
}
function PortInfo(props: IPortInfoProps) {
  const { prefix, countries } = props;
  const intl = useIntl();
  const methods = useFormContext();
  const { setValue, getValues, watch } = methods;
  const [searchPort, setSearchPort] = useState("");
  const [portAddress, setPortAddress] = useState<any>([]);
  const arrivalPortCode = getValues("schedule.arrival_port_code");
  const departurePortCode = getValues("schedule.departure_port_code");
  const country = watch(`schedule.${prefix}_country_name`);
  useEffect(() => {
    if (arrivalPortCode && prefix === "arrival") {
      setSearchPort(arrivalPortCode);
    }
    if (departurePortCode && prefix === "departure") {
      setSearchPort(departurePortCode);
    }
  }, [arrivalPortCode, departurePortCode]);
  useEffect(() => {
    const countryCode = countries.filter((cy) => cy.label?.toLowerCase() === country?.toLowerCase());
    if (countryCode?.length > 0) {
      setValue(`schedule.${prefix}_country_code`, countryCode?.[0]?.value);
    }
  }, [country]);
  useEffect(() => {
    // debounce 300ms for seaport search
    if (searchPort) {
      const timeoutId = setTimeout(() => {
        handleAddressTypeOption();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [searchPort]);
  const handleSelectPort = (item: IPortAddress[]) => {
    setValue(`schedule.${prefix}_port_code`, item?.[0]?.code || item?.[0]?.un_locode);
    setValue(`schedule.${prefix}_city`, item?.[0]?.city_name || "");
    setValue(`schedule.${prefix}_country_name`, item?.[0]?.country_name || "");
    setPortAddress([]);
  };
  const handleAddressTypeOption = () => {
    getSeaports(searchPort)
      .then((res) => {
        const data = res.data.results;
        setPortAddress(data);
        const portDetail = data.filter((pt: IPortAddress) => pt.un_locode === searchPort);
        if (portDetail?.length > 0) {
          const { name, un_locode, country_name } = portDetail[0];
          setValue(`schedule.${prefix}_port_name`, name);
          setValue(`schedule.${prefix}_port_code`, un_locode);
          setValue(`schedule.${prefix}_country_name`, country_name);
        }
      })
      .catch((error) => errorToast(error));
  };
  return (
    <div className="flex-row mid-wrapper mt-4">
      <div className="w-300 dropdown-div">
        <SearchSelect
          shouldUnregister
          preselect={false}
          name={`schedule.${prefix}_port_name`}
          defaultValue={getValues(`schedule.${prefix}_port_name`)}
          placeholder={intl.formatMessage({
            id: "report.search",
            defaultMessage: "Search",
          })}
          label={intl.formatMessage(
            prefix === "departure"
              ? {
                  id: "quote.provider.departurePort",
                  defaultMessage: "Departure port",
                }
              : {
                  id: "quote.provider.arrivalPort",
                  defaultMessage: "Arrival port",
                },
          )}
          onInputChange={(val: string) => {
            setSearchPort(val);
          }}
          options={portAddress.map((option: IPortAddress) => ({
            id: option.id,
            label: option.name,
            value: option.name,
            city_name: option.city_name,
            country_name: option.country_name,
            country_code: option.country_code,
            code: option.code || option.un_locode,
          }))}
          onSelect={(item: IPortAddress[]) => {
            handleSelectPort(item);
          }}
          filterBy={["label", "city_name", "country_name", "code"]}
          handleRenderOption={handleRenderAddressOption}
          required
        />
      </div>
      {country && (
        <div className="ml-2">
          <label className="label">
            <FormattedMessage id="general.country" defaultMessage="Country" />
          </label>
          <h6 className="country-name font-bold">{country}</h6>
        </div>
      )}
    </div>
  );
}
export default PortInfo;
